import { CountriesList } from './countries';
import { PhoneCodesList } from './phoneCodes';
import { CountriesListType } from './types';

const mapEntries = CountriesList.reduce<[string, CountriesListType][]>((acc, cur) => {
  return acc.concat([[cur.key, cur]]);
}, []);

// export const countryMap = new Map<string, { key: string; label: string }>(mapEntries);
export const countryMap = new Map<string, CountriesListType>(mapEntries);
export const getCountryName = (countryCode?: string) => {
  return CountriesList.find((c) => c.key === countryCode)?.label ?? countryCode;
};

/**
 * @deprecated Use shared/components/Country
 */
export const resolveCountryIcon = (value: string) => {
  const country = CountriesList.find((_country) => _country.key === value);

  if (country) {
    return country.icon;
  } else {
    return null;
  }
};

export const PhoneCodesListForm = PhoneCodesList.map((code) => ({
  ...code,
  key: code.value,
}));
